import { render, staticRenderFns } from "./ExploreObservatories.vue?vue&type=template&id=3969d078&scoped=true&"
import script from "./ExploreObservatories.vue?vue&type=script&lang=js&"
export * from "./ExploreObservatories.vue?vue&type=script&lang=js&"
import style0 from "./ExploreObservatories.vue?vue&type=style&index=0&id=3969d078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969d078",
  null
  
)

export default component.exports